import React, { useState } from "react";
import { FieldInput, FieldTextArea, FieldSection, FieldButton } from "@/components/ui/Field";
import { useGolemErrors } from "@/lib/golem/useGolemErrors";
import { type APIError } from "@/api/APIError";
import { ErrorBox } from "@/components/ui/ErrorBox";

type PartnerFormProps = {
    initialName?: string;
    initialDescription?: string;
    submitLabel: string;
    onSubmit: (name: string, description: string | null) => Promise<void>;
};

export function PartnerForm({ initialName = "", initialDescription = "", submitLabel, onSubmit }: PartnerFormProps) {
    const golemErrors = useGolemErrors();
    const [name, setName] = useState(initialName);
    const [description, setDescription] = useState(initialDescription);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<APIError | null>(null);

    const handleSubmit = async () => {
        setError(null);
        golemErrors.clearErrors();
        setSubmitting(true);
        try {
            await onSubmit(name, description || null);
        } catch (e: unknown) {
            const err = e as APIError;
            golemErrors.setFromError(err);
            setError(err);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <ErrorBox error={error} />
            <div className="bg-white shadow-md rounded-md p-6 flex flex-col gap-6">
                <FieldSection title="Partner Details" first>
                    <FieldInput label="Name" value={name} onChange={setName} errors={golemErrors} field="name" placeholder="Partner name" required />
                    <FieldTextArea label="Description" value={description} onChange={setDescription} errors={golemErrors} field="description" placeholder="Optional description" rows={3} maxRows={12} />
                </FieldSection>
                <div className="flex justify-end">
                    <div className="w-36">
                        <FieldButton text={submitLabel} loading={submitting} onClick={handleSubmit} />
                    </div>
                </div>
            </div>
        </>
    );
}
